import { Link } from "react-router-dom";

export const NavBar = ({addressMachine, nameEmpresa}) => {
    return(
        <div className="row border border-1 inter-regular text-black p-2 font14 mb-5 d-flex justify-content-between">
        <div className="col-12 col-sm-6 col-md-6 col-lg-6">
          <div className="text-start">
            <Link to="/" className="text-decoration-none">
            <svg 
            xmlns="http://www.w3.org/2000/svg"
            width={28}
            height={16}
            fill="currentColor"
            className="bi bi-geo-alt-fill"
            viewBox="0 2 18 18">
              <path d="M 12 2 A 1 1 0 0 0 11.289062 2.296875 L 1.203125 11.097656 A 0.5 0.5 0 0 0 1 11.5 A 0.5 0.5 0 0 0 1.5 12 L 4 12 L 4 20 C 4 20.552 4.448 21 5 21 L 9 21 C 9.552 21 10 20.552 10 20 L 10 14 L 14 14 L 14 20 C 14 20.552 14.448 21 15 21 L 19 21 C 19.552 21 20 20.552 20 20 L 20 12 L 22.5 12 A 0.5 0.5 0 0 0 23 11.5 A 0.5 0.5 0 0 0 22.796875 11.097656 L 12.716797 2.3027344 A 1 1 0 0 0 12.710938 2.296875 A 1 1 0 0 0 12 2 z"></path>
            </svg>
            {nameEmpresa ? (
                <span>&#187;</span>
              ) : (
                <span> </span>
              )}
            </Link>{" "}
            <Link to={-1} className="text-decoration-none">
              {nameEmpresa ? (
                <span>{nameEmpresa} &#187;</span>
              ) : (
                <span> </span>
              )}
            </Link>
          </div>
        </div>
       
        {addressMachine ? (
          <div className="col-12 col-sm-6 col-md-6 col-lg-6">
            <div className="row d-flex align-center">
              <div className="col-12 col-sm-6 col-md-6 col-lg-6">
                <h6  className="navbar-h6">Usted ha escogido como punto retiro:</h6>
              </div>
              <div className="col-12 col-sm-6 col-md-6 col-lg-6">
              <div className="navbar-row-text">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width={18}
                  height={18}
                  fill="#0e6efd"
                  className="bi bi-geo-alt-fill"
                  viewBox="0 0 16 16"
                >
                  <path d="M8 16s6-5.686 6-10A6 6 0 0 0 2 6c0 4.314 6 10 6 10m0-7a3 3 0 1 1 0-6 3 3 0 0 1 0 6" />
                </svg>
                {" "}
                
                    {addressMachine}
                </div>
                
              </div>
              </div>
          </div>
           
          ): (<span> </span>)}
        
      </div>
    )
}